// middleware/api.js

function checkStatus(response) {
  //   if (!response.ok) {
  //       throw Error(response.statusText);
  //   }
  //   return response;
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    return response.json().then((response) => {
      var error = new Error(response);
      error.response = response;
      return Promise.reject(error);
    });
  }
}

function callApi(endpoint, authenticated, config = {}, params) {
  let token = localStorage.getItem("access_token") || null;
  let id_pos = localStorage.getItem("id_pos") || null;

  config = {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Accept-language": "es",
    },
    ...config,
  };

  if (authenticated) {
    if (token) {
      if (id_pos !== "undefined") {
        config.headers = {
          Authorization: `Bearer ${token}`,
          pos: id_pos,
          ...config.headers,
        };
      } else {
        config.headers = {
          Authorization: `Bearer ${token}`,
          ...config.headers,
        };
      }
    } else {
      config.headers = {
        ...config.headers,
      };
      //throw new Error('No token or pos saved!');
    }
  }

  let url = new URL(endpoint);
  if (params) {
    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key])
    );
  }

  return fetch(url, config)
    .then(checkStatus)
    .then((response) => {
      if (response) {
        return response.json().catch(() => response);
      } else {
        return Promise.reject(new Error("token_refreshing"));
      }
    });
}

export const CALL_API = Symbol("Call API");

const apiMiddleware = (store) => (next) => (action) => {
  const callAPI = action[CALL_API];

  if (typeof callAPI === "undefined") {
    return next(action);
  }

  let { endpoint, types, authenticated, config, params, ...rest } = callAPI;

  const [requestType, successType, errorType] = types;
  next({
    type: requestType,
  });

  return callApi(endpoint, authenticated, config, params).then(
    (response) =>
      next({
        response,
        authenticated,
        type: successType,
        ...rest,
      }),
    (error) =>
      next({
        error: error.response,
        type: errorType,
      })
  );
};

export default apiMiddleware;
